export default "__VITE_ASSET__ef3d5608__"